import type { FrontendWidget } from '../types';
import { TutorApplicationFormWidget } from './TutorApplicationFormWidget';
import type {
  TutorApplicationFormRaw,
  TutorApplicationFormResolved,
} from './types';

/**
 * The CMS config is flat — no nested components — so there is nothing to
 * unwrap and `resolveSync` is a passthrough. (Nested components arrive wrapped
 * in arrays by `resolveNestedZones` and cost Strapi performance, which is why
 * this widget avoids them.)
 */
export const tutorApplicationFormWidget: FrontendWidget<
  TutorApplicationFormRaw,
  TutorApplicationFormResolved
> = {
  componentType: 'widgets.tutor-application-form',
  displayName: 'Tutor Application Form',
  ComponentA: TutorApplicationFormWidget,
  resolveSync: (config) => config,
};
